import './App.css';
import Header from "./components/utilities/Header/Header.jsx";
import Footer from "./components/utilities/Footer/Footer.jsx";


function CASloginpage() {

    const devEnv = process.env.REACT_APP_IS_DEV;
  const handleLogin = () => {
    if(parseInt(devEnv)===1){
      console.log(typeof(devEnv));
      window.location.href='/landing'
    }
    else{
      window.location.href='/login'
    }
  };
  return (
    <div >
      
      <Header/>
      <div className="caspage">
      <div className="centerize"> <button
                type="submit"
                className= "buttonstyle buttonforlogin " onClick={handleLogin} > <span class="text">CASLogin</span>
              
             
    
                
              </button>
              </div>

      </div>
      <Footer/>
    </div>
  );
}

export default CASloginpage;